import React, {useState, useEffect, useRef} from "react";
import {Link} from "react-router-dom";
import Tilt from 'react-parallax-tilt';
import Parallax from 'parallax-js';
import SectionTitle from "../../components/SectionTitles/SectionTitle";

const AboutPageWithRadioBtns = ({title, subTitle, mainContent, foregroundImg, backgroundImg}) => {
    const [scale] = useState(1.04);
    const sceneEl = useRef(null);

    useEffect(() => {
        const parallaxInstance = new Parallax(sceneEl.current, {
            relativeInput: true,
        })

        parallaxInstance.enable();

        return () => parallaxInstance.disable();

    }, [])
    return (
        <div className="section section-padding-top section-padding-bottom-180">
            <div className="container">

                <div className="row">

                    <div className="col-xl-7 col-lg-6 col-12" data-aos="fade-up">
                        <div className="about-image-area">
                            <div className="about-image">
                                <Tilt scale={scale} transitionSpeed={4000}>
                                    <img src={`${foregroundImg}`} alt="foregroundImg" />
                                </Tilt>
                                {process.env.PUBLIC_URL}
                            </div>
                            <div className="about-image">
                                <Tilt scale={scale} transitionSpeed={4000}>
                                    <img src={`${backgroundImg}`} alt="backgroundImg" />
                                </Tilt>
                            </div>

                            <div className="shape shape-1" id="scene" ref={sceneEl}>
                                <span data-depth="1"><img src={process.env.PUBLIC_URL + "/images/shape-animation/about-shape-1.png"} alt="" /></span>
                            </div>

                        </div>
                    </div>

                    <div className="col-xl-5 col-lg-6 col-12" data-aos="fade-up" data-aos-delay="300">
                        <div className="about-content-area">
                            <SectionTitle showWithSpan="true"
                                subTitle={subTitle}
                                title={title}
                            />
                            <div className="m-4">
                                <ul>
                                    <li>Analytics and Visualization</li>
                                    <li>Customer Experience</li>
                                    <li>Supply Chain Management</li>
                                    <li>Human Resource Management</li>
                                    <li>Customer Relationship Management</li>
                                    <li>Advisory and Consulting</li>
                                    <li>Enterprise Integration</li>
                                    <li>Transformation Support</li>

                                </ul>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default AboutPageWithRadioBtns;
